export const COMPARISON_TABLE_DATA = [
  {
    id: 'peacock-ingest',
    feature: 'Right to Ingest Peacock Content*',
    otherDistributors: true,
    fubo: false,
  },
  {
    id: 'penetration-terms',
    feature: 'Fair Effective Rates per Subscriber',
    otherDistributors: true,
    fubo: false,
  },
  {
    id: 'cheaper-packages',
    feature: 'Ability to offer Cheaper Sports Packages',
    otherDistributors: true,
    fubo: false,
  },
  {
    id: 'fair-rates',
    feature: 'Fair Market Pay TV Rates',
    otherDistributors: true,
    fubo: false,
  },
]

export const TABLE_FOOTNOTE = '*Includes YouTube TV and Amazon Prime.'
